<template>
  <v-main>
    <v-container>
      <v-card class="mx-auto mt-8" flat max-width="1080">
        <v-row v-if="result == 1">
          <!-- INDICAÇÃO APROVADA -->
          <v-col class="mt-n1" cols="12" md="12">
            <!-- <v-parallax src="../assets/indicacao-aceita.png" ></v-parallax> -->
            <v-img
              src="../assets/indicacao-aceita.png"
              aspect-ratio="2"
              contain
            ></v-img>
            <div
              class="ma-8"
              style="text-align: justify; color: #003ea6; font-weight: 500"
            >
              <div>
                <p>
                  Prezado Dentista
                  <span style="color: #ff0000; font-weight: bold">{{
                    nomeDentista
                  }}</span>
                </p>
                <p>
                  Seus dados foram cadastrados em nosso banco de indicações com
                  sucesso.
                </p>
                <p>
                  Sua indicação
                  <span style="color: #ff0000; font-weight: bold">{{
                    nrIndicacao
                  }}</span>
                  será avaliada pela área de consultoria de relacionamento e
                  gestão de rede, caso seja aprovada encaminharemos a proposta
                  de credenciamento por e-mail para sua avaliação e entraremos
                  em contato para esclarecimentos e orientações sobre o
                  credenciamento.
                </p>
                <p>
                  É importante ressaltar que o envio da proposta não significa
                  que o credenciamento será efetivado, estamos ainda na fase
                  inicial do processo que poderá ser aprovado ou não por
                  qualquer uma das partes.
                </p>
                <p>
                  Caso não seja aprovado, seus dados ficam salvos em nosso banco
                  de indicações para possível contato futuro em caso de
                  necessidade de novos credenciamentos.
                </p>
              </div>
              <div class="ma-8" style="color: #003ea6; font-weight: bold">
                <p>Cordialmente,<br />Equipe de Credenciamento Odontoprev</p>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="result == 2">
          <!-- INDICAÇÃO DIMENSIONADA -->
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="mt-8">
            <v-img
              src="../assets/indicacao-dimensionada.png"
              aspect-ratio="2"
              contain
              height="360"
            ></v-img>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="mt-8">
            <div
              class="ma-2"
              style="text-align: justify; color: #003ea6; font-weight: 500"
            >
              <p>
                Prezado Dentista
                <span style="color: #ff0000; font-weight: bold">{{
                  nomeDentista
                }}</span>
              </p>
              <p>
                Recebemos sua indicação
                <span style="color: #ff0000; font-weight: bold">{{
                  nrIndicacao
                }}</span>
                e agradecemos seu interesse em aderir à Odontoprev, informamos
                que atualmente a rede credenciada na sua cidade
                <span style="color: #ff0000; font-weight: bold">{{
                  cidade
                }}</span>
                está dimensionada ou seja, temos a quantidade de credenciados
                suficiente para o atendimento aos nossos beneficiários nesta
                localidade.
              </p>
              <p>
                Assim sendo, no momento não haverá a possibilidade de
                continuidade da análise de sua indicação e consequente
                credenciamento.
              </p>
              <p>
                Seus dados ficam salvos em nosso banco de indicações para
                possível contato futuro em caso de necessidade de novos
                credenciamentos.
              </p>
              <p>Desde já agradecemos,</p>
              <div class="ma-4" style="color: #003ea6; font-weight: bold">
                <p>Cordialmente,<br />Equipe de Credenciamento Odontoprev</p>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-8" cols="12" md="12">
            <v-btn color="primary" class="mr-4" @click="voltar"
              ><i class="fas fa-arrow-circle-left"></i> &nbsp;Voltar</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data() {
    return {
      result: null,
      nomeDentista: '',
      nrIndicacao: null,
      cidade: null,
    };
  },
  methods: {
    voltar() {
      this.$router.push('/');
    },
  },
  created: function () {
    if (Object.keys(this.$route.params).length !== 0) {
      this.result = this.$route.params.result;
      this.nomeDentista = this.$route.params.nomeDentista;
      this.nrIndicacao = this.$route.params.nrIndicacao;
      this.cidade = this.$route.params.cidade;
    } else {
      // this.result = 2
      // this.nomeDentista = 'TESTE ADRIANO'
      // this.nrIndicacao = 12345678
      // this.cidade = 'São Paulo'
      this.$router.push('/');
    }
  },
};
</script>
